// NPM packages
import React from 'react';
import {
  ButtonProps,
  CircularProgress as MuiCircularProgress,
  CircularProgressProps as MuiCircularProgressProps,
} from '@mui/material';
import { observer } from 'mobx-react-lite';

export interface CircularProgressProps extends MuiCircularProgressProps {
  insideButton?: boolean;
  buttonSize?: ButtonProps['size'];
}

function CircularProgress(
  props: CircularProgressProps
): React.ReactElement | null {
  const style: React.CSSProperties = { ...props.style };
  let size: MuiCircularProgressProps['size'] = props.size;
  if (props.insideButton) {
    size = '1.5rem';
    style.marginRight = '1rem';
    style.color = 'inherit';
    if (props.buttonSize === 'small') {
      style.marginRight = '0.5rem';
      size = '1rem';
    }
  }
  return (
    <MuiCircularProgress
      aria-label="Loading..."
      {...props}
      style={style}
      size={size}
    />
  );
}

export default observer(CircularProgress);
